var React = require('react');

function Pass (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.03571 5.60625V7.4125H2.42857C1.08717 7.4125 0 8.49249 0 9.82083V17.0458C0 18.3742 1.08717 19.4542 2.42857 19.4542H14.5714C15.9109 19.4542 17 18.3742 17 17.0458V9.82083C17 8.49249 15.9109 7.4125 14.5714 7.4125H13.9643V5.60625C13.9643 2.61352 11.5167 0.1875 8.5 0.1875C5.48326 0.1875 3.03571 2.61352 3.03571 5.60625ZM11.5357 5.60625V7.4125H5.46429V5.60625C5.46429 3.94375 6.82277 2.59583 8.5 2.59583C10.1772 2.59583 11.5357 3.94375 11.5357 5.60625ZM8.5 10.9542C7.87408 10.9542 7.36667 11.4616 7.36667 12.0875V14.9208C7.36667 15.5468 7.87408 16.0542 8.5 16.0542C9.12592 16.0542 9.63333 15.5468 9.63333 14.9208V12.0875C9.63333 11.4616 9.12592 10.9542 8.5 10.9542Z","fill":"#ADADAD"}));
}

Pass.defaultProps = {"width":"17","height":"20","viewBox":"0 0 17 20","fill":"none"};

module.exports = Pass;

Pass.default = Pass;
